export default __webpack_public_path__ + "static/media/ri_money-dollar-circle-line.5199060e.svg";